/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPharmacyKits } from 'app/entities/pharmacy-kit/pharmacy-kit.reducer';
import { getEntities as getPharmacyStocks } from 'app/entities/pharmacy-stock/pharmacy-stock.reducer';
import { getEntities as getPharmacyConsumableStocks } from 'app/entities/pharmacy-consumable-stock/pharmacy-consumable-stock.reducer';
import { getEntities as getPharmacyImplantStocks } from 'app/entities/pharmacy-implant-stock/pharmacy-implant-stock.reducer';
import { createEntity, getEntity, reset, updateEntity } from './pharmacy-kit-item.reducer';

export const PharmacyKitItemUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const pharmacyKits = useAppSelector(state => state.pharmacyKit.entities);
  const pharmacyStocks = useAppSelector(state => state.pharmacyStock.entities);
  const pharmacyConsumableStocks = useAppSelector(state => state.pharmacyConsumableStock.entities);
  const pharmacyImplantStocks = useAppSelector(state => state.pharmacyImplantStock.entities);
  const pharmacyKitItemEntity = useAppSelector(state => state.pharmacyKitItem.entity);
  const loading = useAppSelector(state => state.pharmacyKitItem.loading);
  const updating = useAppSelector(state => state.pharmacyKitItem.updating);
  const updateSuccess = useAppSelector(state => state.pharmacyKitItem.updateSuccess);

  const handleClose = () => {
    navigate(`/pharmacy-kit-item${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPharmacyKits({}));
    dispatch(getPharmacyStocks({}));
    dispatch(getPharmacyConsumableStocks({}));
    dispatch(getPharmacyImplantStocks({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.quantity !== undefined && typeof values.quantity !== 'number') {
      values.quantity = Number(values.quantity);
    }
    if (values.expectedQty !== undefined && typeof values.expectedQty !== 'number') {
      values.expectedQty = Number(values.expectedQty);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...pharmacyKitItemEntity,
      ...values,
      kit: pharmacyKits.find(it => it.id.toString() === values.kit?.toString()),
      drugStock: pharmacyStocks.find(it => it.id.toString() === values.drugStock?.toString()),
      consumableStock: pharmacyConsumableStocks.find(it => it.id.toString() === values.consumableStock?.toString()),
      implantStock: pharmacyImplantStocks.find(it => it.id.toString() === values.implantStock?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...pharmacyKitItemEntity,
          kit: pharmacyKitItemEntity?.kit?.id,
          drugStock: pharmacyKitItemEntity?.drugStock?.id,
          consumableStock: pharmacyKitItemEntity?.consumableStock?.id,
          implantStock: pharmacyKitItemEntity?.implantStock?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.pharmacyKitItem.home.createOrEditLabel" data-cy="PharmacyKitItemCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.pharmacyKitItem.home.createOrEditLabel">Create or edit a PharmacyKitItem</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pharmacy-kit-item-id"
                  label={translate('tinyMedicRestApp.pharmacyKitItem.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyKitItem.quantity')}
                id="pharmacy-kit-item-quantity"
                name="quantity"
                data-cy="quantity"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyKitItem.expectedQty')}
                id="pharmacy-kit-item-expectedQty"
                name="expectedQty"
                data-cy="expectedQty"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyKitItem.active')}
                id="pharmacy-kit-item-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyKitItem.microSec')}
                id="pharmacy-kit-item-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyKitItem.lastupdated')}
                id="pharmacy-kit-item-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyKitItem.timestampentry')}
                id="pharmacy-kit-item-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacyKitItem.cursor')}
                id="pharmacy-kit-item-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="pharmacy-kit-item-kit"
                name="kit"
                data-cy="kit"
                label={translate('tinyMedicRestApp.pharmacyKitItem.kit')}
                type="select"
                required
              >
                <option value="" key="0" />
                {pharmacyKits
                  ? pharmacyKits.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="pharmacy-kit-item-drugStock"
                name="drugStock"
                data-cy="drugStock"
                label={translate('tinyMedicRestApp.pharmacyKitItem.drugStock')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyStocks
                  ? pharmacyStocks.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-kit-item-consumableStock"
                name="consumableStock"
                data-cy="consumableStock"
                label={translate('tinyMedicRestApp.pharmacyKitItem.consumableStock')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyConsumableStocks
                  ? pharmacyConsumableStocks.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-kit-item-implantStock"
                name="implantStock"
                data-cy="implantStock"
                label={translate('tinyMedicRestApp.pharmacyKitItem.implantStock')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyImplantStocks
                  ? pharmacyImplantStocks.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pharmacy-kit-item" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PharmacyKitItemUpdate;
